import { createContext, useContext } from "react";
import { useUserManager } from "./useUserManager";

const User = createContext();

export const UserProvider = ({ children, uid }) => {
  const { isLoading, profile, permissions, role } = useUserManager(uid);
  const loading = isLoading || (uid && !profile?._id);

  const hasPermission = (permission) => {
    return permissions?.includes(permission) || false;
  };

  const hasRole = (roles) => {
    if (!role) return false;
    if (Array.isArray(roles)) return roles.includes(role);
    return role === roles;
  };

  return (
    <User.Provider
      value={{
        hasPermission,
        hasRole,
        loading,
        permissions,
        profile,
        role,
        uid,
      }}
    >
      {children}
    </User.Provider>
  );
};

export const useUser = () => useContext(User);
